import { defineComponent as a } from "vue";
import "./AlertDialog.css";
const u = a({
  props: {
    alertTitle: {
      type: String,
      default: ""
    },
    alertContent: {
      type: String,
      default: ""
    },
    divid: {
      type: String,
      default: ""
    },
    showCancel: {
      type: Boolean,
      default: !1
    },
    showOK: {
      type: Boolean,
      default: !0
    },
    yestext: {
      type: String,
      default: "OK"
    },
    notext: {
      type: String,
      default: "Cancel"
    }
  },
  data() {
    return {
      dialogid: "",
      headid: ""
    };
  },
  created() {
    this.dialogid = "dialog" + this.divid, this.headid = "head" + this.divid;
  },
  emits: ["on-confim", "on-cancel", "on-close"],
  methods: {
    confirmDailog() {
      this.$emit("on-confim");
    },
    closeDailog() {
      this.$emit("on-close");
    },
    cancelDailog() {
      this.$emit("on-cancel");
    },
    mousedown(t) {
      var e = document.getElementById(this.dialogid), o = document.getElementById(this.headid);
      o.style.cursor = "move";
      var n = t.clientX - e.offsetLeft, d = t.clientY - e.offsetTop;
      document.onmousemove = function(l) {
        var i = l || t;
        e.style.left = i.clientX - n + "px", e.style.top = i.clientY - d + "px";
      }, document.onmouseup = function() {
        document.onmousemove = null, document.onmouseup = null, o.style.cursor = "default";
      };
    }
  }
});
export {
  u as default
};
